import Difficulty from 'app/frontend/types/custom/Difficulty'
import Season from 'app/frontend/types/custom/Season'

export const defaultEncounterSort = (
  season: Season,
  encounters: wowaudit.Encounter[],
) => {
  const instanceOrderById = new Map(
    season.instances.map((instance) => [
      instance.id,
      instance.orderInSeason ?? 0,
    ]),
  )

  return [...encounters].sort((left, right) => {
    const instanceOrder =
      (instanceOrderById.get(left.instanceId) ?? 0) -
      (instanceOrderById.get(right.instanceId) ?? 0)
    return (
      instanceOrder ||
      left.instanceId - right.instanceId ||
      left.defaultOrder - right.defaultOrder
    )
  })
}

export const sortEncountersForSeason = (
  season: Season,
  difficulty: Difficulty,
  encounterOrders?: wowaudit.Team['encounterOrders'],
) => {
  const encounters = defaultEncounterSort(
    season,
    season.instances.flatMap((instance) => instance.encounters),
  )
  const stored: number[] | undefined =
    encounterOrders?.[season.id.toString()]?.[difficulty]
  if (!stored?.length) return encounters

  const byId = new Map(encounters.map((encounter) => [encounter.id, encounter]))
  const ordered: wowaudit.Encounter[] = []
  const seen = new Set<number>()

  stored.forEach((rawId) => {
    const encounterId = Number(rawId)
    const encounter = byId.get(encounterId)
    if (!encounter || seen.has(encounterId)) return
    ordered.push(encounter)
    seen.add(encounterId)
  })
  encounters.forEach((encounter) => {
    if (seen.has(encounter.id)) return
    ordered.push(encounter)
  })

  return ordered
}
